// ConsensusResearchComponent.js
import React from 'react';
import './consResearchBodyTemplateComponent.scss';

const ConsensusResearchComponent = ({ value }) => {
    let backgroundColor;

    // Handle floating-point values with ranges similar to score2color function
    if (value > 5 && value <= 6) {
        backgroundColor = '#BA290C'; // Very Weak (Dark red)
    } else if (value > 4 && value <= 5) {
        backgroundColor = '#DC6F59'; // Weak (Medium red)
    } else if (value > 3 && value <= 4) {
        backgroundColor = '#9E9E9E'; // Normal (Dark grey)
    } else if (value > 2 && value <= 3) {
        backgroundColor = '#61C101'; // Positive (Light green)
    } else if (value >= 1 && value <= 2) {
        backgroundColor = '#158006'; // Very Positive (Dark green)
    } else {
        backgroundColor = 'transparent'; // Default for invalid values
    }

    return (
        <div className='cons-research-cell'>
            <div className='circle' style={{ backgroundColor }}></div>
        </div>
    );
};

export default ConsensusResearchComponent;